<template>
<div class="shopMobBannerSetting">
    <div class="title">
        <p>图文广告</p>
        <p class="checkCourse">查看教程</p>
    </div>
    <div class="bannerItemBox">
        <SlickList lockAxis="xy" v-model="item.datalist" class="bannerSlickListBox" :distance="5" @input="sortEndList">
            <SlickItem v-for="(item, index2) in item.datalist" :index="index2" :key="index2" class="bannerSlickItemBox">
                <div class="bannerItem">
                    <div class="bannerBox">
                        <img :src="item.banner.furl" alt="">
                        <!-- <el-upload class="upload-demo" :action="uploadSetting.uploadurl" :imgRule="imgRule">
                            <div class="edit" @click="editBanner">修改</div> -->
                            <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload> -->
                        <shopUpload :uploadType="uploadType" @setFile="setFile" :index='index2' :fileRule="imgRule"></shopUpload>
                    </div>
                    <div class="contentBox">
                        <el-form ref="form" :model="item" label-width="75px">
                            <el-form-item label="标题">
                                <el-input v-model="item.objectname" placeholder="请输入标题"></el-input>
                            </el-form-item>
                            <el-form-item label="跳转页面">
                                <el-select v-model="item.urltype" placeholder="请选择链接页面" @click.native="choiceLink(item.urltype)">
                                    <el-option v-for="(item, index) in pageList" :key="index" @click.native="linkPage(index2)" :label="item.name" :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="urlTitle text-ellipse" v-if="item.urltype==1">
                                <span>页面名称：</span>
                                <span v-if="!!item.objectdesc || item.linkname"><span v-if="item.objectdesc || item.linkname">{{item.urlname}} | </span>{{item.objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="item.urltype==2">
                                <span>商品名称：</span> 
                                <span v-if="!!item.objectdesc || item.linkname">{{item.kmctypeText}} | {{item.objectdesc || item.linkname}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="item.urltype==5">
                                <span>分组名称：</span>
                                <span v-if="!!item.objectdesc || item.linkname">{{item.objectdesc}}</span>
                            </div>
                            <div class="urlTitle text-ellipse" v-if="item.urltype==7">
                                <span>链接：</span>
                                <span v-if="!!item.tourl">{{item.tourl}}</span>
                            </div>
                        </el-form>
                    </div>
                    <i @click="deleteBannerItem(index)" class="el-icon-error"></i>
                </div>
            </SlickItem>
        </SlickList>
    </div>
    <div class="addBox" @click="addBanner">
        <p class="add"><i class="el-icon-circle-plus-outline"></i> 添加轮播图</p>
        <p class="addTips">建议尺寸750*280像素</p>
    </div>
    <p class="bannerTips">最多添加10个轮播图，拖动选中的轮播图可对其排序</p>
    <banner ref="banner" @setShop='setLink' :index="index" @cancel="cancel"></banner>
    <customLink ref="customLink" @setLink='customLink' @cancel="cancel"></customLink>
    <group ref="group" @setGroup="setGroup" @cancel="cancel"></group>
    <commodity ref="commodity" @setCommodity="setCommodity" @cancel="cancel"></commodity>
</div>
</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort'
import {mapGetters, mapActions} from 'vuex'
import shopUpload from 'base/upload/shopUpload'
import Banner from '../dataComponents/banner'
import CustomLink from '../dataComponents/customLink'
import Group from '../dataComponents/group'
import Commodity from '../dataComponents/commodity'
import $ from 'jquery'
// import bannerSetting from '@/'
export default {
    name: 'shopMobBannerSetting',
    data() {
        return {
            link: '',
            item: {
                cominnerid: '',
                label: '活动信息',
                comtype: 'imagead',
                isdisplaytitle: 1,
                titlename: '',
                isdisplayall: 1,
                datasource: 1,
                liststyle: 'detail',
                tagname: '',
                taginnerid: '',
                datacount: 2,
                datalist: [
                    {
                        objectname: '',
                        urltype: 1,
                        tourl: 'www.baidu.com',
                        linkname: '',
                        kmctype: '',
                        objectdesc: ' ',
                        banner: {
                            keyid: '',
                            furl: ''
                        }
                    }
                ]
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            imgRule: {
                btnName: '修改',
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: 100,
                height: 100
            },
            pageList: [
                {code: 1, name: '单个微页面'},
                {code: 2, name: '单个商品'},
                {code: 3, name: '我的消息'},
                {code: 4, name: '我的已购'},
                {code: 5, name: '商品分组'},
                {code: 6, name: '默认微页面'},
                {code: 7, name: '自定义链接'}
            ],
            index: ''
        }
    },
    mounted() {
        this.shopMob.forEach(obj => {
            if (obj.comtype === 'imagead') {
                this.item = $.extend(true, {}, obj)
            }
        })
    },
    methods: {
        choiceLink(urltype) {
            this.link = urltype
        },
        cancel() {
            this.item.datalist[this.index].urltype = this.link
        },
        sortEndList(list) {
            this.item.datalist = list
        },
        setGroup(row) {
            this.item.datalist[this.index].urltype = 5
            this.item.datalist[this.index].objectdesc = row.name
            this.item.datalist[this.index].tourl = row.innerid
        },
        setCommodity(datalist) {
            this.item.datalist[this.index].urltype = 2
            this.item.datalist[this.index].linkname = datalist.kmcname
            this.item.datalist[this.index].kmctypeText = datalist.kmctypeText
            this.$set(this.item.datalist[this.index], 'objectdesc', datalist.kmcname)
            this.item.datalist[this.index].tourl = datalist.kmcinnerid
            this.item.datalist[this.index].kmctype = datalist.kmctype
        },
        setLink(page) {
            this.item.datalist[this.index].tourl = page.innerid
            this.item.datalist[this.index].linkname = page.pagename
            if (page.isdefault) {
                this.item.datalist[this.index].urlname = '主页'
            } else {
                this.item.datalist[this.index].urlname = ''
            }
            this.item.datalist[this.index].objectdesc = page.pagename
            this.item.datalist[this.index].urltype = 1
        },
        customLink(link) {
            this.item.datalist[this.index].linkname = link
            this.item.datalist[this.index].tourl = link
            this.item.datalist[this.index].urltype = 7
        },
        linkPage(v) {
            this.index = v
            this.item.datalist[v].objectdesc = ''
            this.item.datalist[v].urlname = ''
            this.item.datalist[v].tourl = ''
            if (this.item.datalist[v].urltype === 1) {
                this.$refs.banner.openDialog()
            } else if (this.item.datalist[v].urltype === 7) {
                this.$refs.customLink.openDialog()
            } else if (this.item.datalist[v].urltype === 5) {
                this.$refs.group.openDialog([this.item.datalist[this.index]])
            } else if (this.item.datalist[v].urltype === 2) {
                this.$refs.commodity.openDialog()
            }
            // this.item.datalist[v].urltype = ''
        },
        addBanner() {
            this.item.datalist.push({
                objectname: '',
                urltype: 1,
                tourl: '',
                linkname: '',
                banner: {
                    keyid: '',
                    furl: ''
                }
            })
        },
        deleteBannerItem(index) {
            this.item.datalist.splice(index, 1)
        },
        setFile(file) {
            this.item.datalist[file.index].banner.furl = file.furl
            this.item.datalist[file.index].banner.keyid = file.keyid
        },
        ...mapActions([
            'setShopMob'
        ])
    },
    filters: {},
    watch: {
        item: {
            handler: function() {
                let tmpList = $.extend(true, [], this.shopMob)
                let obj = $.extend(true, {}, this.item)
                tmpList.splice(this.selectCom.index, 1, obj)
                this.setShopMob(tmpList)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {
        SlickList, SlickItem, shopUpload, Banner, CustomLink, Group, Commodity
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobBannerSetting {
    position: absolute;
    top:0;
    left: 102%;
    width: 548px;
    box-sizing: border-box;
    padding: 15px 20px 20px;
    background: #F5F7FA;
    // min-height: 310px;
    border: 1px solid #E4E7ED;
    // height: 0;
    .title{
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid #DCDFE6;
        .checkCourse{
            color: #409EFF;
            cursor: pointer;
        }
    }
    .bannerTips{
        color: #606266;
        margin-top: 10px;
    }
    .bannerItem{
        width: 508px;
        height: 120px;
        display: flex;
        border: 1px solid #D8DCE6;
        padding: 20px 10px;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        .bannerBox{
            position: relative;
            width: 214px !important;
            height: 80px !important;
            border: 1px solid $line;
            img{
                width: 214px;
                height: 80px;
            }
            .shopUpload{
                .upload-demo{
                    .el-upload{
                        .el-button{
                            position: absolute;
                            top: 0;
                            width: 214px;
                            height: 80px;
                            background: rgba(0,0,0,.4);
                            display: none;
                        }
                    }
                }
            }
        }
        .bannerBox:hover{
            .shopUpload{
                .upload-demo{
                    .el-upload{
                        .el-button{
                            display: block;
                        }
                    }
                }
            }
        }
        .contentBox{
            flex: 1;
            overflow: hidden;
            .urlTitle{
                margin-left: 10px;
                color: $tcolor-grey;
                font-size: 14px;
            }
            .el-form-item{
                margin-bottom: 10px;
                .el-form-item__label{
                    font-size: 14px;
                    text-align: left;
                    padding-right: 6px;
                    box-sizing: border-box;
                    text-indent: 12px;
                }
                .el-form-item__content{
                    width: 190px;
                    .el-input__icon{
                        line-height: 32px;
                    }
                }
            }
        }
        .el-icon-error{
            color: #909399;
            position: absolute;
            font-size: 20px;
            top: -10px;
            right: -10px;
            cursor: pointer;
        }
        .el-icon-error:hover{
            color: #409EFF;
        }
    }
    .addBox{
        width: 508px;
        height: 70px;
        border: 1px solid #DCDFE6;
        background: #fff;
        text-align: center;
        margin-top: 15px;
        line-height: 35px;
        font-size: 14px;
        cursor: pointer;
        .add{
            color: #409EFF;
        }
        .addTips{
            color: #909399;
        }
    }
}
.bannerSlickItemBox{
    margin-top: 20px;
}
.bannerItemBox{
    .bannerItem{
        display: flex;
        border: 1px solid #D8DCE6;
    }
}
</style>
